import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaCamera,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EventVideoRecordingInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Event Video Recording in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Capture Your Moments</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Event Video Recording</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our event video recording services in **Al
            Barsha** capture the essence of your special occasions with
            cinematic quality. From weddings to corporate events, we create
            vibrant, engaging videos that preserve your memories and tell your
            story.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Event videographer in action
          "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Corporate event setup
          "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Wedding celebration
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Book Your Event"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Event Video Recording in Al Barsha"
        description="We deliver high-quality event videos that preserve every moment."
        cards={[
          {
            icon: <FaCamera color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "Stunning visuals that capture the event’s energy.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Videos that highlight key moments and emotions.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround to relive your event sooner.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Content optimized for sharing on social media and websites.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Service",
            description: "Al Barsha’s choice for event videography.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Comprehensive Coverage",
            description: "From setup to highlights, we capture it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Event Video Recording Process"
        description={
          <Description>
            We capture your events with precision and creativity through a
            streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your event’s vision and requirements.
              </li>
              <li>
                Planning: Coordinate logistics and key moments to capture.
              </li>
              <li>
                Filming: Use professional equipment for high-quality footage.
              </li>
              <li>
                Editing: Craft a polished video with effects, music, and
                transitions.
              </li>
              <li>Review: Ensure the video meets your expectations.</li>
              <li>
                Delivery: Provide a final video ready for sharing or archiving.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1505236858219-8359eb29e329?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Event filming equipment
          "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Event crowd in Dubai
          "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Event video editing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Event Video Wins in Al Barsha"
        description="Our event videos have preserved cherished memories in Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Memorable Weddings",
            description:
              "Captured emotional highlights for a couple’s big day.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Corporate Impact",
            description: "Boosted engagement with a conference highlight reel.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction from event video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Capture Your Event?</Subheading>}
        heading="Event Video Recording in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional event video recording
            in Al Barsha. Create cinematic, high-quality videos that preserve
            your moments and tell your story—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Elegant Dubai event venue
          "https://images.unsplash.com/photo-1531058020387-3be344556be6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Professional cameraman filming
          "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Corporate event in Dubai
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
